var map = {
	"./Icon-0.png": 2249,
	"./Icon-1.png": 6000,
	"./Icon-2.png": 9819,
	"./Icon-3.png": 9314,
	"./Icon-4.png": 1037,
	"./Icon-5.png": 9908,
	"./announcement.png": 1284,
	"./comfirmation-icon.png": 9025,
	"./confirmation.png": 8894,
	"./contact_us.png": 6858,
	"./edit_profile.png": 2251,
	"./hotel_booking.png": 627,
	"./language.png": 4879,
	"./orderHistory.png": 4785,
	"./payment-icon.png": 885,
	"./payment.png": 5127,
	"./pre-booking-icon.png": 4608,
	"./process-icon.png": 6054,
	"./process.png": 8882,
	"./purchase_his-icon.png": 2007,
	"./security_center.png": 4871,
	"./user.png": 5056,
	"./withdraw_details.png": 5776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8810;